import {
    FormField, FormFieldType, AsyncObjectType, FormFieldVisibility,
} from "../../__generated__/api";
import { ReplacementGroup } from "../replacement-group";

export enum ExecutorFields {
    CAN_SET,
    CANT_SET
}

export function createUserField(label: string, description: string, prefix: string) {
    return {
        id: `urn:fq:form-field-group:${prefix}`,
        label,
        description,
        input: [
            {
                id: `urn:fq:form-field:${prefix}-name`,
                name: "Name",
                type: FormFieldType.Text,
                isSystemField: true,
                visibility: FormFieldVisibility.Reusable,
            },
            {
                id: `urn:fq:form-field:${prefix}-firstName`,
                name: "First Name",
                type: FormFieldType.Text,
                isSystemField: true,
                visibility: FormFieldVisibility.Reusable,
            },
            {
                id: `urn:fq:form-field:${prefix}-lastName`,
                name: "Last Name",
                type: FormFieldType.Text,
                isSystemField: true,
                visibility: FormFieldVisibility.Reusable,
            },
            {
                id: `urn:fq:form-field:${prefix}-email`,
                name: "Email",
                type: FormFieldType.Text,
                isSystemField: true,
                visibility: FormFieldVisibility.Reusable,
            },
            {
                id: `urn:fq:form-field:${prefix}`,
                name: "Creator",
                type: FormFieldType.User,
                isSystemField: true,
                visibility: FormFieldVisibility.Reusable,
            },
        ],
    };
}

export const REQUEST_FIELD_INPUTS = [
    {
        id: "urn:fq:form-field:status",
        name: "Status",
        type: FormFieldType.AsyncDropdown,
        asyncObjectType: AsyncObjectType.ChatStatus,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
    },
    {
        id: "urn:fq:form-field:priority",
        name: "Priority",
        type: FormFieldType.AsyncDropdown,
        asyncObjectType: AsyncObjectType.Priority,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
    },
    {
        id: "urn:fq:form-field:severity",
        name: "Severity",
        type: FormFieldType.AsyncDropdown,
        asyncObjectType: AsyncObjectType.Severity,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
    },
    {
        id: "urn:fq:form-field:ticket-severity-label",
        name: "Severity Label",
        type: FormFieldType.Text,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
    },

    {
        id: "urn:fq:form-field:subject",
        name: "Subject",
        type: FormFieldType.Text,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
    },
    {
        id: "urn:fq:form-field:description",
        name: "Description",
        type: FormFieldType.LongText,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
    },
    {
        id: "urn:fq:form-field:requestType",
        name: "Request Type",
        type: FormFieldType.AsyncDropdown,
        asyncObjectType: AsyncObjectType.RequestType,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
    },
    {
        id: "urn:fq:form-field:ticket-number",
        name: "Ticket number",
        type: FormFieldType.Text,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
    },
    {
        id: "urn:fq:form-field:ticket-state",
        name: "Column Id",
        type: FormFieldType.AsyncDropdown,
        asyncObjectType: AsyncObjectType.TicketState,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
    },
    {
        id: "urn:fq:form-field:ticket-tags",
        name: "Tags",
        type: FormFieldType.MultiSelectDropdown,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
    },

    {
        id: "urn:fq:form-field:ticket-guest-url",
        name: "Guest Ticket URL",
        type: FormFieldType.Text,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
    },
    {
        id: "urn:fq:form-field:ticket-agent-url",
        name: "Agent Ticket URL",
        type: FormFieldType.Text,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
    },

    {
        id: "urn:fq:form-field:created-date",
        name: "Create Date",
        type: FormFieldType.Date,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
    },

    {
        id: "urn:fq:form-field:first-response-date",
        name: "First Response Date",
        type: FormFieldType.Date,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
    },

];

export const REQUEST_FIELDS: ReplacementGroup = {
    id: "urn:fq:form-field-group:request",
    label: "Request Fields",
    description: "Request information",
    input: [...REQUEST_FIELD_INPUTS, {
        id: "urn:fq:form-field:fields",
        name: "Field Name",
        type: FormFieldType.AsyncDropdown,
        asyncObjectType: AsyncObjectType.FieldInContext,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
        options: REQUEST_FIELD_INPUTS.map(field => ({
            label: field.name,
            value: field.id,
        })),
    },
    ],

};

export const SYSTEM_FIELD_INPUTS = [

    {
        id: "urn:fq:form-field:date-now",
        name: "Current Date",
        type: FormFieldType.Date,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
    },

    {
        id: "urn:fq:form-field:date-now",
        name: "Current Date/Time",
        type: FormFieldType.DateTime,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
    },
    {
        id: "urn:fq:form-field:time-now",
        name: "Current Time",
        type: FormFieldType.Time,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
    },
];

export const SYSTEM_FIELDS: ReplacementGroup = {
    id: "urn:fq:form-field-group:system",
    label: "System fields",
    description: "System fields and helpers",
    input: [...SYSTEM_FIELD_INPUTS, {
        id: "urn:fq:form-field:fields",
        name: "Field Name",
        type: FormFieldType.AsyncDropdown,
        asyncObjectType: AsyncObjectType.FieldInContext,
        isSystemField: true,
        visibility: FormFieldVisibility.Private,
        options: SYSTEM_FIELD_INPUTS.map(field => ({
            label: field.name,
            value: field.id,
        })),
    },
    ],

};

export const REQUESTOR_FIELDS = createUserField("Requester Fields", "Information about the requester.", "requestor");

export const EXECUTOR_FIELDS = createUserField(
    "Executor Fields",
    "Information about user what executed this action.",
    "executed-by",
);

export const ASSIGNEE_FIELDS = createUserField(
    "Assignee Fields",
    "If the ticket is assigned, information about the current assignee.",
    "assignee",
);

export const CREATOR_FIELDS = createUserField("Creator Fields", "Information about the creator.", "creator");

export const SOURCE_FIELDS = {
    id: "urn:fq:form-field-group:source",
    label: "Source Fields",
    description: "Request source information",
    input: [
        {
            id: "urn:fq:form-field:source-name",
            name: "Name",
            type: FormFieldType.Text,
            isSystemField: true,
            visibility: FormFieldVisibility.Reusable,
        },
        {
            id: "urn:fq:form-field:source-url",
            name: "Url",
            type: FormFieldType.Text,
            isSystemField: true,
            visibility: FormFieldVisibility.Reusable,
        },
    ],
};

export default function createFormFields(formFields: FormField[], executor = ExecutorFields.CANT_SET) {
    const requestDefaults = REQUEST_FIELD_INPUTS
        .map(input => (!formFields.some(row => row.id === input.id) ? input : undefined)).filterNull();

    return [
        {
            id: "urn:fq:form-field-group:request",
            label: "Request Fields",
            description: "The fields entered by the end user.",
            input: formFields.concat([...requestDefaults, {
                id: "urn:fq:form-field:fields",
                name: "Field Name",
                type: FormFieldType.AsyncDropdown,
                asyncObjectType: AsyncObjectType.FieldInContext,
                isSystemField: true,
                visibility: FormFieldVisibility.Private,
                options: formFields.map(field => ({
                    label: field.name,
                    value: field.id,
                })),
            },
            ]),
        },
        REQUESTOR_FIELDS,
        CREATOR_FIELDS,
        ASSIGNEE_FIELDS,
        SOURCE_FIELDS,
        SYSTEM_FIELDS,

        executor === ExecutorFields.CANT_SET
            ? undefined
            : EXECUTOR_FIELDS,
    ].filterNull();
}
